import apiRequest from './apiRequest';

/**
 * Delete character by ID (DELETE /characters/:characterID).
 * If the requester is the creator, S3 objects under the character path are deleted
 * and the upload record is soft-deleted; all access records for the character are removed.
 * @see https://api-docs.getcartwheel.com/api/call-delete-character
 */
export default async function externalDeleteCharacter(apiKey: string, characterID: string) {
  return apiRequest<Record<string, never>>(
    'external-mogen',
    `/characters/${encodeURIComponent(characterID)}`,
    {
      method: 'DELETE',
      headers: {
        'x-api-key': apiKey,
      },
    },
  );
}
